module.exports = __webpack_public_path__ + "static/media/MonthView.4e9f0d1c.svg";